import React from 'react';
import PropTypes from 'prop-types';
import { Text, View } from 'react-native';

import defaultStyles from './TextHeader.jss';

const TextHeader = ({ title, testID }) => (
    <View style={defaultStyles.container} testID={testID}>
        <Text style={defaultStyles.label} numberOfLines={1}>
            {title}
        </Text>
    </View>
);

TextHeader.defaultProps = {
    testID: undefined
};

TextHeader.propTypes = {
    title: PropTypes.string.isRequired,
    testID: PropTypes.string
};

export default TextHeader;
